import { useEffect, useState } from "react";
import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "react-bootstrap";
import { connect, useDispatch, useSelector } from "react-redux";

import { getInmuebles } from "../../../redux/Sections/Inmuebles/actions";
import { Tabla } from "../../../components/Table/Table";
import { v4 as uuidv4 } from "uuid";
import icon from "../../../assets/static/images/secciones/inmuebles.png";
import DescargarExcel from "../../../components/DescargarExcel/DescargarExcel";
import AlertInfo from "../../../components/AlertInfo";
import { getAbogados } from "../../../redux/Sections/Abogados/actions";
import { setLoading } from "../../../redux/Loading/actions";
import { situacionesService } from "../../../_services/situaciones.service";
import { RowDeudas } from "./Components/RowDeudas/RowDeudas";
import { Filter } from "./Components/Filter/Filter";


// INMUEBLE, RECURSO, DOMICILIO, BARRIO, NOMENCLATURA, PARTIDA Y NOMBRE DEL CONTRIBUYENTE 
const columns = [
  {
    title: "INMUEBLE",
    dataIndex: "NRO_INMUEBLE",
    key: "NRO_INMUEBLE",
  },
  {
    title: "RC",
    dataIndex: "RECURSO",
    key: "RECURSO",
  },
  {
    title: "DOMICILIO",
    dataIndex: "DOMICILIO",
    key: "DOMICILIO",
  },
  {
    title: "BARRIO",
    dataIndex: "BARRIO",
    key: "BARRIO",
  },
  {
    title: "NOMENCLATURA",
    dataIndex: "NOMENCLATURA",
    key: "NOMENCLATURA",
  },
  {
    title: "PARTIDA",
    dataIndex: "PARTIDA",
    key: "PARTIDA",
  },
  {
    title: "CONTRIBUYENTE",
    dataIndex: "APYNOM",
    key: "APYNOM",
  },
];


const formatData = (dataTable) => {
  if (dataTable && dataTable?.length) {
    return dataTable.map((e, i) => {
      const {
        CALLE, NRO, PISO, DEPT,
        PAR_PROVINCIAL,
        CIRCUNS,
        SECCION,
        CHACRA_NRO,
        CHACRA_LET,
        QUINTA_NRO,
        QUINTA_LET,
        FRACCION_NRO,
        FRACCION_LET,
        MANZANA_NRO,
        MANZANA_LET,
        PARCELA_NRO,
        PARCELA_LET,
        UNI_FUNCIONAL,
      } = e;

      return {
        id: i,
        uuid: uuidv4(),
        ...e,
        DOMICILIO: `${CALLE || ""} ${NRO || ""} ${PISO ? ` - PISO: ${PISO}` : ""} ${DEPT ? `DEPT: ${DEPT}` : ""}`,
        NOMENCLATURA: `
        ${CIRCUNS ? `CIRCUNS: ${CIRCUNS}` : ""} ${SECCION ? `- SECCION: ${SECCION}` : ""} ${CHACRA_NRO ? `- CHACRA_NRO: ${CHACRA_NRO}` : ""} ${CHACRA_LET ? `- CHACRA_LET: ${CHACRA_LET}` : ""}
        ${QUINTA_NRO ? `- QUINTA_NRO: ${QUINTA_NRO}` : ""} ${QUINTA_LET ? `- QUINTA_LET: ${QUINTA_LET}` : ""} ${FRACCION_NRO ? `- FRACCION_NRO: ${FRACCION_NRO}` : ""} ${FRACCION_LET ? `- FRACCION_LET: ${FRACCION_LET}` : ""}
        ${MANZANA_NRO ? `- MANZANA_NRO: ${MANZANA_NRO}` : ""} ${MANZANA_LET ? `- MANZANA_LET: ${MANZANA_LET}` : ""} ${PARCELA_NRO ? `- PARCELA_NRO: ${PARCELA_NRO}` : ""} ${PARCELA_LET ? `- PARCELA LET: ${PARCELA_LET}` : ""}
        ${UNI_FUNCIONAL ? `- SUBPARCELA: ${UNI_FUNCIONAL}` : ""}`,
        PARTIDA: `${PAR_PROVINCIAL ? `PARTIDA: ${PAR_PROVINCIAL}` : ""}`
      };
    });
  } else {
    return [];
  }
};

const Inmuebles = ({ getData, inmueblesData, getAbogados, abogados }) => {
  const dispatch = useDispatch();
  const [showFilter, setShowFilter] = useState(true);
  const { showTable } = useSelector(state => state.dashboard);
  const [situaciones, setSituaciones] = useState([]);
  
  useEffect(() => {
    const getData = async () => {
      dispatch(setLoading(true));

      let response = await situacionesService.getSituaciones();

      if (response?.length) {
        setSituaciones(response.map(e => {
          return {
            ...e,
            value: e.CODIGO,
            label: e.DETALLE_SITUACION
          };
        }));

        dispatch(setLoading(false));
      }
      else {
        dispatch(setLoading(false));
      }
    };

    getData();
  }, []);

  useEffect(() => {
    if (showTable) {
      setShowFilter(false);
    }

  }, [showTable]);

  useEffect(() => {
    getAbogados();
  }, []);

  function exportData(list) {
    let filename =`inmuebles_${new Date().getTime()}.xlsx`;

    const dataList = list.map((e) => {
      const {
        CALLE, NRO, PISO, DEPT,
        PAR_PROVINCIAL,
        CIRCUNS,
        SECCION,
        CHACRA_NRO,
        CHACRA_LET,
        QUINTA_NRO,
        QUINTA_LET,
        FRACCION_NRO,
        FRACCION_LET,
        MANZANA_NRO,
        MANZANA_LET,
        PARCELA_NRO,
        PARCELA_LET,
        UNI_FUNCIONAL,
      } = e;

      return {
        "INMUEBLE": e.NRO_INMUEBLE,
        "RECURSO": e.RECURSO,
        "DOMICILIO": `${CALLE || ""} ${NRO || ""} ${PISO ? ` - PISO: ${PISO}` : ""} ${DEPT ? `DEPT: ${DEPT}` : ""}`,
        "BARRIO": e.BARRIO,
        "NOMENCLATURA": `
        ${CIRCUNS ? `CIRCUNS: ${CIRCUNS}` : ""} ${SECCION ? `- SECCION: ${SECCION}` : ""} ${CHACRA_NRO ? `- CHACRA_NRO: ${CHACRA_NRO}` : ""} ${CHACRA_LET ? `- CHACRA_LET: ${CHACRA_LET}` : ""}
        ${QUINTA_NRO ? `- QUINTA_NRO: ${QUINTA_NRO}` : ""} ${QUINTA_LET ? `- QUINTA_LET: ${QUINTA_LET}` : ""} ${FRACCION_NRO ? `- FRACCION_NRO: ${FRACCION_NRO}` : ""} ${FRACCION_LET ? `- FRACCION_LET: ${FRACCION_LET}` : ""}
        ${MANZANA_NRO ? `- MANZANA_NRO: ${MANZANA_NRO}` : ""} ${MANZANA_LET ? `- MANZANA_LET: ${MANZANA_LET}` : ""} ${PARCELA_NRO ? `- PARCELA_NRO: ${PARCELA_NRO}` : ""} ${PARCELA_LET ? `- PARCELA LET: ${PARCELA_LET}` : ""}
        ${UNI_FUNCIONAL ? `- SUBPARCELA: ${UNI_FUNCIONAL}` : ""}`,
        "PARTIDA": `${PAR_PROVINCIAL ? `PARTIDA: ${PAR_PROVINCIAL}` : ""}`,
        "CONTRIBUYENTE": e.APYNOM
      };
    });

    let name = "Inmuebles";

    return {
      dataList,
      filename,
      name
    };
  }

  return (
    <div className="section-container section-content">
      <div className="section-title d-flex align-items-center">
        <img src={icon} alt="contribuyente" />
        <span>Inmuebles</span>
      </div>

      <div className="buttons-filter">
        <h3 className="mr-3">Filtros:</h3>
        <div className="button-filter">
          {showFilter ? (
            <Button
              variant="danger"
              onClick={() => setShowFilter(false)}
              className="danger-button d-flex align-items-center"
              style={{ maxWidth: 105 }}
            >
              <FontAwesomeIcon icon={faArrowDown} size="1x" /><span className="ml-2">Ocultar</span>
            </Button>
          )
            : (
              <Button
                onClick={() => setShowFilter(true)}
                className="custom-button d-flex align-items-center"
                style={{ maxWidth: 105 }}
              >
                <FontAwesomeIcon icon={faArrowUp} size="1x" /><span className="ml-2">Mostrar</span>
              </Button>
            )}
        </div>
      </div>
      <div className="section-filter">
        <Filter showFilter={showFilter} setShowFilter={setShowFilter} style={{ marginBottom: "30px" }} action={getData} section="inmuebles" />
      </div>
      {showTable ? (
        <div className="section-table">
          {inmueblesData?.length ? (
            <AlertInfo>
              <div className="d-flex align-items-center">
                Haga click en
                <div className="d-flex mx-1">
                  <button type="button" className="ant-table-row-expand-icon ant-table-row-expand-icon-collapsed" aria-label="Expand row"></button>
                </div>
                para ver la deuda del inmueble.
              </div>
            </AlertInfo>
          ) : null}
          <Tabla 
            dataList={formatData(inmueblesData)} 
            columns={columns} 
            expandable={true} 
            selection={false}
            RowData={RowDeudas} 
            inmuebles={true}
            abogados={abogados}
            situaciones={situaciones}
          />
          <div className="mt-3">
            <div style={{ maxWidth: 170 }}>
              <DescargarExcel data={exportData(inmueblesData)} addDeuda />
            </div>
          </div>
        </div>
      ) : null}
    </div>

  );
};


const mapStateToProps = (state) => {
  return {
    inmueblesData: state.dashboard.inmueblesList,
    abogados: state.dashboard.abogadosList,
    loading: state.dashboard.loading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getData: (data) => dispatch(getInmuebles(data)),
    getAbogados: () => dispatch(getAbogados()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Inmuebles);